import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { IncidentQuantumDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-incident-quantum-container',
  templateUrl: './incident-quantum-container.component.html',
  styleUrls: ['./incident-quantum-container.component.scss'],
})
export class IncidentQuantumContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  incidentquantums$: Observable<IncidentQuantumDto[]>;
  loading: boolean;
  isLoadingIncidentQuantum$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingIncidentQuantum$ = this.gatwayFacade.isLoadingGateway(
      'IncidentQuantumOfImpact'
    );
    this.incidentquantums$ = this.gatwayFacade.loadGateway(
      'IncidentQuantumOfImpact'
    );
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteIncidentQuantum(deletedValue: any) {
    this.gatwayFacade.remove('IncidentQuantumOfImpact', deletedValue);
  }

  // this method control both the create and update

  onSubmitIncidentQuantum(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.IncidentQuantums;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllIncidentQuantum = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllIncidentQuantum.push(pullData[i]);
      }
    }

    // check if the addAllIncidentQuantum array is not empty, then dispatch the data to the store
    if (addAllIncidentQuantum.length > 0) {
      this.gatwayFacade.add('IncidentQuantumOfImpact', addAllIncidentQuantum);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('IncidentQuantumOfImpact', allUpdates, ['id']);
    }
  }
}
